import styled from 'styled-components';

export const StyledTopCategoriesTab = styled('div')`
  display: flex;
  .levels {
    display: flex;
    gap: 10px;
    padding-top: 30px;
    flex-wrap: wrap;
    > div {
      padding: 0 0 20px 0;
    }
  }

  .buttons {
    padding: 15px;
  }
`;
